import { SolicitacaoCompartilhamento } from "./SolicitacaoCompartilhamento";

export default SolicitacaoCompartilhamento